<template lang="pug"></template>

<script>
export default {
    name: 'BotaoConfiguracaoRastreabilidade',
    componentOptions: {
        title: 'Configuração da Rastreabilidade',
        actions: [
            [
                {
                    name: 'Configuração da Rastreabilidade',
                    showView: false,
                    action: 'abrirConfiguracaoRastreabilidade',
                    route: 'ConfiguracaoRastreabilidade',
                    nameTranslationKey:
                        'mensagens.menuLateral.configuracaoRastreabilidade'
                }
            ]
        ]
    },

    methods: {
        abrirConfiguracaoRastreabilidade() {
            if (this.$route.name !== 'ConfiguracaoRastreabilidade') {
                this.$router.push({ name: 'ConfiguracaoRastreabilidade' });
            } else {
                this.$router.go();
            }
        }
    }
};
</script>
